// Studyo Today Backend
// Package studyo.today.demo.v1
// Service definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/demo/v1/resources/snapshot.proto (package studyo.today.demo.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file studyo/today/demo/v1/resources/snapshot.proto.
 */
export const file_studyo_today_demo_v1_resources_snapshot = /*@__PURE__*/
  fileDesc("Ci1zdHVkeW8vdG9kYXkvZGVtby92MS9yZXNvdXJjZXMvc25hcHNob3QucHJvdG8SHnN0dWR5by50b2RheS5kZW1vLnYxLnJlc291cmNlcyJVCghTbmFwc2hvdBIMCgRuYW1lGAEgASgJEigKBHRpbWUYAiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhEKCXNjaG9vbF9pZBgDIAEoCUImqgIjU3R1ZHlvLlRvZGF5LkRlbW8uR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw", [file_google_protobuf_timestamp]);

/**
 * Describes the message studyo.today.demo.v1.resources.Snapshot.
 * Use `create(SnapshotSchema)` to create a new message.
 */
export const SnapshotSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_demo_v1_resources_snapshot, 0);

